import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import ReConsentModal from "./ReConsentModal";

/**
 * Blocks interaction via modal when user needs re-consent or a mutation returned CONSENT_REQUIRED.
 * Remounts the modal on route changes so it reappears if removed from the DOM without accepting.
 */
const ConsentGate = () => {
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);
  const consentModalRequired = useSelector((state) => state.auth.consentModalRequired);
  const consentModalNonce = useSelector((state) => state.auth.consentModalNonce);

  const shouldShow = Boolean(user) && (user.needs_reconsent || consentModalRequired);

  if (!shouldShow) {
    return null;
  }

  return <ReConsentModal key={`${location.key}-${consentModalNonce}`} />;
};

export default ConsentGate;
